'use client';

import { DownloadIcon } from '@radix-ui/react-icons';

type ViewMode = 'html' | 'pdf' | 'markdown';

interface ViewModeToggleProps {
  pdfUrl: string;
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
  /** When true the left button toggles Markdown; otherwise HTML. */
  hasMarkdown?: boolean;
  /** Outer wrapper classes. Defaults to the sidebar shape (`px-4 pb-3`). */
  wrapperClassName?: string;
}

const buttonBase = 'flex-1 px-3 py-1.5 text-sm font-medium transition-colors';
const buttonActive = 'bg-brand-tertiary/15 text-brand-tertiary';
const buttonInactive = 'text-content-secondary hover:bg-surface-elevated';

export default function ViewModeToggle({
  pdfUrl,
  viewMode,
  onViewModeChange,
  hasMarkdown = false,
  wrapperClassName = 'px-4 pb-3',
}: ViewModeToggleProps) {
  const leftMode: ViewMode = hasMarkdown ? 'markdown' : 'html';
  const leftLabel = hasMarkdown ? 'Markdown' : 'HTML';

  return (
    <div className={wrapperClassName}>
      <div className='flex rounded-lg border border-line-default overflow-hidden'>
        <button
          type='button'
          onClick={() => onViewModeChange(leftMode)}
          className={`${buttonBase} ${
            viewMode === leftMode ? buttonActive : buttonInactive
          }`}
        >
          {leftLabel}
        </button>
        <button
          type='button'
          onClick={() => onViewModeChange('pdf')}
          className={`${buttonBase} border-l border-line-default ${
            viewMode === 'pdf' ? buttonActive : buttonInactive
          }`}
        >
          PDF
        </button>
        <a
          href={pdfUrl}
          target='_blank'
          rel='noopener noreferrer'
          className='flex items-center justify-center px-2.5 py-1.5 border-l border-line-default text-content-secondary hover:bg-surface-elevated transition-colors'
          aria-label='Download PDF'
        >
          <DownloadIcon className='h-3.5 w-3.5' />
        </a>
      </div>
    </div>
  );
}
